import { useTimeoutFn } from '@vueuse/core';
import { shallowRef } from 'vue';

export function useAutoClearError<T>(delayMs: number) {
    const error = shallowRef<T | null>(null);
    const timer = useTimeoutFn(() => {
        error.value = null;
    }, delayMs, { immediate: false });

    function showTemporary(nextError: T) {
        error.value = nextError;
        timer.start();
    }

    function showPersistent(nextError: T) {
        timer.stop();
        error.value = nextError;
    }

    function clear() {
        timer.stop();
        error.value = null;
    }

    return { error, showTemporary, showPersistent, clear };
}
